import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { MAILTO_URL } from "@/constants/links";

const NAV = [
    { label: "Hizmetler", href: "#hizmetler" },
    { label: "Süreç", href: "#surec" },
    { label: "Çalışmalar", href: "#calismalar" },
    { label: "Hakkımızda", href: "#hakkimizda" },
    { label: "İletişim", href: "#iletisim" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <>
            <header
                data-testid="header-nav-container"
                className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
                    scrolled || open
                        ? "bg-ink/90 backdrop-blur-md border-b border-cream/10"
                        : "border-b border-transparent"
                }`}
            >
                <div className="mx-auto flex h-16 w-full max-w-[1240px] items-center justify-between px-6 md:h-20 md:px-10">
                    <a
                        href="#top"
                        data-testid="header-logo"
                        className="flex items-center"
                    >
                        <img
                            src="/logo.png"
                            alt="Bi Kadraj Media"
                            className="h-7 w-auto md:h-8"
                        />
                    </a>

                    <nav
                        className="hidden items-center gap-8 lg:flex"
                        aria-label="Ana menü"
                    >
                        {NAV.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                data-testid={`nav-link-${item.href.slice(1)}`}
                                className="text-sm text-cream/70 underline-offset-8 transition-colors hover:text-cream hover:decoration-brick hover:underline hover:decoration-2"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>

                    <div className="flex items-center gap-3">
                        <a
                            href="#iletisim"
                            data-testid="header-cta"
                            className="hidden border border-cream/30 px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.18em] text-cream transition-colors hover:bg-cream hover:text-ink sm:inline-flex"
                        >
                            Bizimle Çalışın
                        </a>
                        <button
                            type="button"
                            data-testid="mobile-menu-button"
                            aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
                            onClick={() => setOpen((v) => !v)}
                            className="inline-flex h-10 w-10 items-center justify-center text-cream lg:hidden"
                        >
                            {open ? (
                                <X className="h-6 w-6" />
                            ) : (
                                <Menu className="h-6 w-6" />
                            )}
                        </button>
                    </div>
                </div>
            </header>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="fixed inset-0 top-16 z-40 bg-ink lg:hidden"
                >
                    <div className="flex h-full flex-col px-6 pb-10 pt-6">
                        <nav className="flex flex-col" aria-label="Mobil menü">
                            {NAV.map((item, i) => (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    data-testid={`mobile-nav-${item.href.slice(1)}`}
                                    onClick={() => setOpen(false)}
                                    className="flex items-baseline gap-4 border-b border-cream/10 py-4"
                                >
                                    <span className="text-xs text-cream/30">
                                        0{i + 1}
                                    </span>
                                    <span className="font-display text-3xl text-cream">
                                        {item.label}
                                    </span>
                                </a>
                            ))}
                        </nav>
                        <a
                            href={MAILTO_URL}
                            data-testid="mobile-menu-cta"
                            className="mt-8 bg-cream px-6 py-4 text-center text-sm font-semibold uppercase tracking-[0.18em] text-ink"
                        >
                            Bize Yaz
                        </a>
                    </div>
                </div>
            )}
        </>
    );
}
